export type AssetClassId = 'fixedincome' | 'fx' | 'fxforward' | 'fxswap' | 'irs';
export default interface AssetClass {
    id:AssetClassId;
    name:string;
}

export const DefaultAssetClasses : Array<AssetClass> = [
    {id: 'fixedincome', name: 'Fixed Income'},
    {id: 'fx', name: 'FX Spot'},
    {id: 'fxforward', name: "FX Forward"},
    {id: 'fxswap', name: 'FX Swap'},
    {id: 'irs', name: 'Interest Rate Swap'}
];

// The asset classes this environment's config has dashboards for. FX Swap is
// in the tpicap config only, so every other environment's menu is unchanged.
export function availableAssetClasses(dashboards: object): Array<AssetClass> {
    return DefaultAssetClasses.filter((ac) => dashboards != null && ac.id in dashboards);
}